module.exports = __webpack_public_path__ + "img/bb_platform_06.6d2cdc90.svg";